import { isProPackageUpdatePhase1, isProPackageUpdatePhase2 } from "@/utils/toggle";

// Begin PLAN_TYPES
export const PLAN_TYPES = {
  FREE_BASIC: 'free_basic',
  WEBINAR: 'webinar',
  CMR: 'cmr',
  LARGE_MEETING: 'large',
  ZOOM_MEETING: 'zoom_meeting',
  ZOOM_ONE_EDU_SCHOOL_PLUS: 'zoom_one_edu_school_plus',
  ZOOM_EVENTS: 'zoom_events',
  ZOOM_PHONE: 'pbx',
  ZOOM_ROOMS: 'zr',
  TRANSLATED_CAPTIONS: 'translation_captions',
  ZOOM_ONE: 'pro',
  TEAM_CHAT: 'team_chat',
  LIVE_CHAT: 'livechat',
  MAIL: 'mail',
  CALENDAR: 'calendar',
  ZOOM_WHITEBOARD: 'whiteboard',
  ROOM_CONNECTOR: 'rc',
  TOLLFREE: 'tollfree',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HEALTHCARE_AGREEMENT: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION: 'translation',
  VIDEO_SDK_TRANSLATION: 'videosdk_tt',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  Bundle_CREDIT: 'bundleCredit',
  ZOOM_MESH: 'zoom_mesh',
  ZVA: 'zva',
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  EVENTS_UNLIMITED_ADDITIONAL_HOST: 'eventsaas-additionalhost',
  EVENTS_UNLIMITED_ADDITIONAL_CO_EDITOR: 'eventsaas-additionalcoeditor',
  SESSIONS_UNLIMITED_ADDITIONAL_HOST: 'eventsaascore-additionalhost',
  SESSIONS_UNLIMITED_ADDITIONAL_CO_EDITOR: 'eventsaascore-additionalcoeditor',
  API_CSP: 'api_csp',
  LDKCRC: 'video_sdk_crc',
  ZOOM_SPOTS: 'zoom_spots',
  WORKFORCE_ENGAGEMENT: 'workforce_engagement',
  ZSU: 'ZSU',
  PNM: 'pnm',
  ZOOM_COMMON: 'common',
  VIDEO_SDK_SESSION: 'LDP',
  VIDEO_SDK_CLOUD_RECORDING: 'videosdk_cmr',
  VIDEO_SDK_TRANSLATION_TRANSCRIPTION: 'ZVDKTT',
  AUDIO_CONFERENCING: 'ADP',
  VIDEO_SDK_CLOUD_ROOM_CONNECTOR: 'videosdk_crc',
  WEBINAR_SESSIONS: 'ZECSU',
  ZOOM_SCHEDULER: 'zsched',
  ZONE_BASIC_PLUS: 'zone_basic_plus',
  ZOOM_EVENTS_PPA: 'eventsaas_consumption',
  ZOOM_SESSIONS_PPA: 'eventsaascore_consumption',
  CONFERENCE_ROOM_CONNECTOR: 'roomconnector',
  ZOOM_CLIPS: 'clips',
  ZOOM_NOTES: 'notes',
  AI_COMPANION: 'ai',
  VIDEO_SDK_BUNDLE_CREDIT: 'uc',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_CLIPS_PLUS: 'zclips',
  VISITOR_MANAGEMENT: 'visitor_management',
  DRIVE: 'drive',
  ZOOM_REVENUE_ACCELERATOR: 'zoom_revenue_accelerator',
  CONCURRENT_MEETING_BASIC: 'concurrency_meeting_basic',
  CONCURRENT_MEETING_PLUS: 'ccm',
  ZOOM_WHITEBOARD_PLUS: 'zwbplus',
  ENTERPIRSE_NAMED_HOST: 'enterprise_bundle',
  ZOOM_COMPLIANCE_MANAGER: 'zoom_compliance_manager',
  ZOOM_COMPLIANCE_STORAGE: 'zcm_storage',
  ZOOM_DOCS: 'docs',
  ZOOM_STA_DOC: 'zdocs',
  ZOOM_ONE_BIZ: 'biz',
  PSO: 'pso',
  ZOOM_TASKS: 'tasks',
};

// For more PLAN_CATEGORY_CODE see the java project billing-commons-dto com.saasbee.webapp.billing.enums.ServiceCategoryCode
export const PLAN_CATEGORY_CODES = {
  PRO: 'PRO',
  BUSINESS: 'BIZ',
  CLOUD_STORAGE: 'CMR',
  WEBINAR: 'WBN',
  LARGE_MEETING: 'LMT',
  WHITEBOARD: 'ZWB',
  TRANSLATED_CAPTIONS: 'ZTRANSL',
  ZOOM_SCHEDULER: 'ZSCHED',
  ZOOM_EVENTS: 'ZET',
  ZOOM_SESSIONS: 'ZETZEC',
  ZOOM_ROOMS: 'ZRM',
  TOLLFREE: 'ADR',
  ZOOM_PHONE: 'ZMV',
  CONFERENCE_ROOM_CONNECTOR: 'RCN',
  ZOOM_ONE_BIZ_PLUS: 'ZONEBIZP',
  ZOOM_ONE_PRO_PLUS: 'ZONEPROP',
  ZOOM_CLIPS_PLUS: 'ZCLIPS',
  BASIC_PLUS: 'ZOBASICP',
  LDKCMR: 'LDKCMR',
  ZOOM_REVENUE_ACCELERATOR: 'ZKW',
  CONCURRENT_MEETING_BASIC: 'CCM',
  CONCURRENT_MEETING_PLUS: 'CMS',
  ZCM: 'ZCMPM',
  ZOOM_STA_DOC: 'ZDOCS',
  ENTERPIRSE_NAMED_HOST: 'ENTBD',
  ZOOM_ONE_EDU: 'ZONEDU',
  PSO: 'PSO',
};

export const BASE_PLAN_SUB_TYPES = {
  PRO: 'pro',
  PRO25: 'pro25',
  PRO50: 'pro50',
  PRO_FREE_TRIAL: 'pro_freetrial',
  BIZ: 'biz',
  BIZ_INR: 'biz_inr',
  EDU: 'edu',
  ZOOM_ONE_EDU: 'zonedu',
  EDUCATION: 'education',
  ENTERPRISE: 'bundle',
  EDU_SITE: 'edu_site',
  HC_PRO: 'hc_pro',
  HC_BIZ: 'hc_biz',
  ZOOM_ONE_BIZ_FOR_GOV: 'zone_biz_for_gov',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_ONE_ENTERPRISE: 'zone_enterprise',
  ZOOM_ONE_ENTERPRISE_PLUS: 'zone_enterprise_plus',
  WHITEBOARD_BASIC: 'zwbbasic',
  WHITEBOARD_PLUS: 'zwbplus',
  ZOOM_PHONE: 'pbx',
  ZOOM_REVENUE_ACCELERATOR: 'zm_kiwi',
};

export const QUANTITY_UNIT = {
  USER: 'user',
  LICENSE: 'license',
};

const proPlusCmrCapacity = isProPackageUpdatePhase2() ? 10 : 5;
export const MEETING_DEFAULT_CMR_CAPACITY = isProPackageUpdatePhase1()
  ? {
    PRO: 10,
    PRO_PLUS: proPlusCmrCapacity,
    BIZ: 10,
    BIZ_PLUS: 15,
    SCHOLL: 5,
    SCHOLL_PLUS: 10,
    SCHOLL_ENTERPRISE: 10,
  }
  : {
    PRO: 5,
    PRO_PLUS: proPlusCmrCapacity,
    BIZ: 5,
    BIZ_PLUS: 10,
    SCHOLL: 5,
    SCHOLL_PLUS: 10,
    SCHOLL_ENTERPRISE: 10
  };
